export default {
  // 获取后台菜单
  getMenu:{
    method:'get',
    url:'/v1/cms/AdminAuthMenu'
  }

}